export const DEFAULT_RESPONSIVE_LAYOUT = {
    small: { slides: 1, slidesToMove: 1 },
    medium: { slides: 2, slidesToMove: 1 },
    large: { slides: 3, slidesToMove: 1 },
};
export const DEFAULT_SLIDE_MARGIN = 8;
export const INITIAL_SLIDES_CONFIG = [1, 1];
export const breakpoints = [
    "(min-width: 1280px)",
    "(min-width: 1024px)",
    "(min-width: 768px)",
    "(min-width: 320px)",
];
export function initSlides(resLayout) {
    var _a, _b, _c, _d;
    return [
        [
            ((_a = resLayout.xlarge) === null || _a === void 0 ? void 0 : _a.slidesToMove) ||
                resLayout.large.slidesToMove > ((_b = resLayout.xlarge) === null || _b === void 0 ? void 0 : _b.slides) ||
                resLayout.large.slides
                ? 1
                : ((_c = resLayout.xlarge) === null || _c === void 0 ? void 0 : _c.slidesToMove) || resLayout.large.slidesToMove,
            ((_d = resLayout.xlarge) === null || _d === void 0 ? void 0 : _d.slides) || resLayout.large.slides,
        ],
        [
            resLayout.large.slidesToMove > resLayout.large.slides
                ? 1
                : resLayout.large.slidesToMove,
            resLayout.large.slides,
        ],
        [
            resLayout.medium.slidesToMove > resLayout.medium.slides
                ? 1
                : resLayout.medium.slidesToMove,
            resLayout.medium.slides,
        ],
        [
            resLayout.small.slidesToMove > resLayout.small.slides
                ? 1
                : resLayout.small.slidesToMove,
            resLayout.small.slides,
        ],
    ];
}
